import { Layout } from '@/components/Layout';
import { TransactionList } from '@/components/wallet/TransactionList';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useTransactions } from '@/hooks/useTransactions';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const TransactionHistoryPage = () => {
  const { transactions, loading } = useTransactions();
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="container mx-auto px-4 py-8 max-w-[1200px]">
        <div className="mb-6">
          <Button
            variant="ghost"
            onClick={() => navigate('/wallet')}
            className="mb-4"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Wallet
          </Button>
          <h1 className="text-3xl font-bold mb-2">Transaction History</h1>
          <p className="text-muted-foreground">
            View all your transactions ({transactions.length} total)
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>All Transactions</CardTitle>
          </CardHeader>
          <CardContent>
            <TransactionList transactions={transactions} loading={loading} />
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default TransactionHistoryPage;